let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ecn3O")).then(() => parcelRequire('ls6Dz'));